<div class="content-wrapper">
    <p>If you have forgotten your password, please enter the email address you used to register on the system and
        press
        &ldquo;Request Password Reset&rdquo;. You will then be sent an email containing a link which will allow you to
        select a
        new
        password.</p>
    @if(form) {
    <lib-metaform-display [form]="form" [showErrors]="false" [showButtons]="false"
        (formEvent)="onFormEvent($event)"></lib-metaform-display>
    }
    <app-cf-button [type]="ButtonType.SignIn" [style]="ButtonStyle.Wide" [enabled]="buttonEnabled" (click)="sendReset()"
        [showProcessing]="isProcessing">Request Password Reset</app-cf-button>
    <p>If you have forgotten the email address you used to register on the system, please call <a
            href="tel:+442075817373">+44 (0) 207 581 7373</a> and request
        the Applications Department.</p>
    <tracker-buttons [hasPreviousButton]="true"></tracker-buttons>
</div>